<template>
  <article class="related-article">
    <div class="related-article-image">
      <img
        v-if="article.image"
        :src="article.image"
        :alt="article.alt"
      >
    </div>
    <div class="related-article-content">
      <h3
        v-if="article.title"
        class="related-article-content-title"
      >
        {{ article.title }}
      </h3>
      <p
        v-if="article.intro"
        class="related-article-content-intro"
      >
        {{ article.intro }}
      </p>
      <kf-link
        v-if="article.href"
        :href="article.href"
        class="related-article-content-link"
      />
    </div>
  </article>
</template>

<script>
import KfLink from '@/components/base/link/Link';

export default {
  name: 'KfRelatedArticlesItem',
  components: {
    KfLink,
  },
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="postcss">
.related-article {
  @apply relative flex flex-col border-b border-gray-100 pb-7 mb-9;

  @screen md {
    @apply px-14 pb-10 mb-10 flex-row;
  }

  &:hover {
    .related-article-image {
      > img {
        @apply opacity-70;
      }
    }

    .related-article-content-title {
      @apply text-primary-bravo;
    }
  }

  &-image {
    @apply bg-primary-bravo flex overflow-hidden rounded-sm mr-28 flex-shrink-0 flex-grow-0 mb-5;
    display: flex;
    width: 180px;
    height: 180px;

    @screen md {
      @apply self-center mb-0;
    }

    > img {
      @apply flex object-cover object-center w-full h-full self-center;
      transition: opacity 250ms;

    }
  }

  &-content {
    @apply flex flex-col w-full justify-center;

    &-title {
      @apply text-black;
      transition: color 250ms;
    }

    &-intro {
      @apply mb-0;
    }

    &-link {
      @apply absolute top-0 left-0 bottom-0 right-0;
    }
  }
}
</style>

